import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import "./upd.css";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import Direct from "./direct";
import Parciality from "./parciality";
import Consolidated from "./consolidated";
import axios from "axios";
import Swal from "sweetalert2";

function UPD() {
  const [awb, setAwb] = useState("");
  const [viewUPDData, setViewUPDData] = useState("input");
  const [dataMaster, setDataMaster] = useState("input");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChangeUPD = (e) => {

    let value = e.target.value; 
    if (value.length > 3 && value[3] !== "-") {
        value = value.slice(0, 3) + "-" + value.slice(3);
    }

    setAwb(value);
    if (error) setError('');
    
    setError("");
  };

  const handleSearch = async () => {
    const pattern = /^\d{3}-\d+$/;
    if (!awb.trim) {
      setError("Este campo es obligatorio");
      return;
    }
    if (!pattern.test(awb.trim())) {
      setError("Formato de master invalido");
      return;
    }

    setError("");
    setLoading(true);

    const params = {
      awb: awb,
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_upd/upd_data`,
        {
          params: params,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      if (response.data.error === true) {
        setLoading(false);
        Swal.fire({
          title: "La master no existe favor de verificar",
          icon: "warning",
          iconColor: "#FCC732",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }


      let data = response.data.body;
      const {
        view
      } = data;

      switch (view) {
        case "parciality":
          setLoading(false);
          setViewUPDData("form-parcial");
          setDataMaster(data);
          return

        case "direct":
          setLoading(false);
          setViewUPDData("form-activo");
          setDataMaster(data);
          return
        case "consolidated":
          setLoading(false);
          setViewUPDData("form-consolidated");
          setDataMaster(data);
          return

        default:
          setLoading(false);
          setViewUPDData("input");
          break;
      }


    } catch (error) {
      setLoading(false);
      if (error.response && error.response.data) {
        Swal.fire("Error", error.response.data.body.message, "error");
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos", "error");
      }

    }



    // if (pattern.test(awb.trim())) {
    //   // Aquí colocas la lógica simulada
    //   if (awb.includes("0808")) {
    //     // Ejemplo: guías activas
    //     setViewUPDData("form-activo");
    //   } else if (awb.includes("0909")) {
    //     // Ejemplo: guías parciales
    //     setViewUPDData("form-parcial");
    //   } else {
    //     // Por ahora, si no coincide, igual puedes dirigir a una por defecto o mostrar error
    //     setError("La master no existe, favor de verificar");
    //   }
    // } else {
    //   setError("Ingrese la guía correctamente");
    // }

  };

  const handleBackToParent = () => {
    setViewUPDData("input"); // Regresa a la vista principal
    setAwb(""); // Opcional: limpia el campo
    setDataMaster("input"); // Limpia la data si lo deseas
  };

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        {viewUPDData === "input" && (
          <div className="row justify-content-center">
            <div className="col-6">
              <label htmlFor="inputMaster" className="amc-label">
                Master
              </label>
              <input
                type="text"
                className="form-control"
                id="inputMaster"
                value={awb}
                onChange={handleInputChangeUPD}
              />
              {error && (
                <div className="text-danger mt-2">
                  {error}
                </div>
              )}
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" onClick={handleSearch}>
                  Buscar
                </button>
              </div>
            </div>
          </div>
        )}

        {viewUPDData === "form-activo" && (
          <Direct
            masterNumber={awb}
            dataMaster={dataMaster}
            onBack={handleBackToParent} 
          />
        )}

        {viewUPDData === "form-parcial" && (
          <Parciality
            masterNumber={awb}
            dataMaster={dataMaster}
            onBack={handleBackToParent} 
          />
        )}

        {viewUPDData === "form-consolidated" && (
          <Consolidated
            masterNumber={awb}
            dataMaster={dataMaster}
            onBack={handleBackToParent} 
          />
        )}
      </div>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default UPD;
